<div mdbModal #modalOpcionesAsignacion="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{backdrop: true, ignoreBackdropClick: false}">
  <div class="modal-dialog " role="document">
    <div class="modal-content" style="width: max-content;">
      <div class="modal-header">
        <h4 class="modal-title w-100" id="myModalLabel">{{ title }}</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        {{ contentText }}
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default btn-sm waves-light" data-dismiss="modal" (click)="cancel()"
          mdbWavesEffect>Cancelar</button>
        <!-- <button  [disabled]="loading === false" type="button" class="btn btn-success btn-sm waves-light" (click)="accept()"
          mdbWavesEffect>
          <div class="spinner-border spinner-border-sm" *ngIf="loading === true">
            <mdb-spinner spinnerColor="transparent"></mdb-spinner>
          </div>
          Aceptar</button> -->
        <app-api-button *ngIf="Asignado === true" (click2)="liberar()" [processing]="processing"> Liberar </app-api-button>
        <app-api-button *ngIf="Asignado === false" (click2)="asignar()" [processing]="processing"> Asignar </app-api-button>
        <app-api-button  *ngIf="Asignado === true" (click2)="reasignar()" [processing]="processing"> Reasignar </app-api-button>

      </div>
    </div>
  </div>
</div>
